import React, { Component } from 'react';

export class Layout extends Component {
    static displayName = Layout.name;
    //adds the navbar to the webpage currently being used, and is then exported to App.js to display everything
    //written in class based react, this should be converted to hook based sometime, but is a very low priority
    render() {
        return (
            <div>
                <div id="page">
                    {this.props.children}
                </div>
            </div>
        );
    }
}
